import styled from "@emotion/styled";
import colorOpacity from "@/shared/utils/colorOpacity";

export const FOOTER_HEIGHT = 200;
const isDarkMode = (theme: any) => theme.palette.mode === "dark";

export const FooterWrapper = styled.footer`
  display: flex;
  align-items: center;
  height: ${({ theme }) => theme.coefficient * FOOTER_HEIGHT}px;
  background: ${({ theme }) =>
    isDarkMode(theme) ? theme.colors.value_48 : theme.colors.value_01};
  box-shadow: 0 4px 40px
    ${({ theme }) => colorOpacity(theme.colors.value_18, 0.15)};
  border-top: 1px solid
    ${({ theme }) => (isDarkMode(theme) ? theme.colors.value_33 : "transparent")};
  padding: 0 ${({ theme }) => theme.coefficient * 40}px 0
    ${({ theme }) => theme.coefficient * 40}px;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.coefficient * 24}px;
`;

export const BlockFooter = styled.div`
  width: 100%;
  background: ${({ theme }) =>
    isDarkMode(theme) ? theme.colors.value_48 : theme.colors.color_48};
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: flex-end;
`;
